import { extend } from 'flarum/common/extend';
import app from 'flarum/forum/app';
import UserPage from 'flarum/forum/components/UserPage';
import LinkButton from 'flarum/common/components/LinkButton';
import CustomProfilePageComponent from './pages/CustomProfilePage';
export default function addUserProfilePage() {
  // Ayarları güvenli bir şekilde bulmak için yardımcı fonksiyon
  const getUrlSlug = () => {
    var _data$apiDocument;
    const attributeName = 'huseyinfiliz-custom-profile-page.url_slug';

    // 1. Durum: app.forum hazırdır (Sayfa geçişlerinde vs.)
    if (app.forum) {
      return app.forum.attribute(attributeName);
    }

    // 2. Durum: app.forum hazır değil, ham veriye (Payload) bakacağız.
    const data = app.data;

    // A) Ana dökümana bak (Anasayfadaysak buradadır)
    if (((_data$apiDocument = data.apiDocument) == null || (_data$apiDocument = _data$apiDocument.data) == null ? void 0 : _data$apiDocument.type) === 'forums') {
      var _data$apiDocument$dat;
      return (_data$apiDocument$dat = data.apiDocument.data.attributes) == null ? void 0 : _data$apiDocument$dat[attributeName];
    }

    // B) Resources dizisine bak (Profil sayfasındaysak "forums" buraya saklanmıştır)
    // Önceki debug kodunuzda burası çalışmıştı.
    if (Array.isArray(data.resources)) {
      const forumResource = data.resources.find(r => r.type === 'forums');
      if (forumResource != null && forumResource.attributes) {
        return forumResource.attributes[attributeName];
      }
    }

    // C) Hiçbiri yoksa
    return null;
  };

  // Ayarı çek, yoksa varsayılanı kullan
  const settingSlug = getUrlSlug();
  const urlSlug = settingSlug || 'customPage';

  // Rotayı oluştur (Artık "test" veya ayarlı kelime neyse o gelecek)
  app.routes['user.customPage'] = {
    path: "/u/:username/".concat(urlSlug),
    component: CustomProfilePageComponent
  };

  // Kullanıcı profili menüsüne butonu ekle
  extend(UserPage.prototype, 'navItems', function (items) {
    var _app$forum, _app$session$user, _app$forum2, _app$forum3, _app$forum4, _app$forum5;
    const user = this.user;
    if (!user) return;

    // Yetki kontrolleri
    const canView = (_app$forum = app.forum) == null ? void 0 : _app$forum.attribute('canViewCustomPage');
    const canEdit = ((_app$session$user = app.session.user) == null ? void 0 : _app$session$user.id()) === user.id() && ((_app$forum2 = app.forum) == null ? void 0 : _app$forum2.attribute('canEditOwnCustomPage'));
    if (!canView && !canEdit && !((_app$forum3 = app.forum) != null && _app$forum3.attribute('canModerateCustomPage'))) {
      return;
    }
    const tabTitle = ((_app$forum4 = app.forum) == null ? void 0 : _app$forum4.attribute('huseyinfiliz-custom-profile-page.tab_title')) || 'Custom Page';
    const tabIcon = ((_app$forum5 = app.forum) == null ? void 0 : _app$forum5.attribute('huseyinfiliz-custom-profile-page.tab_icon')) || 'fas fa-file-alt';
    items.add('customPageLink', LinkButton.component({
      href: app.route('user.customPage', {
        username: user.slug()
      }),
      name: 'custompage',
      icon: tabIcon
    }, tabTitle), 85);
  });
}